import { render, staticRenderFns } from "./Fundraisers.vue?vue&type=template&id=4d826d23&scoped=true&"
import script from "./Fundraisers.vue?vue&type=script&lang=js&"
export * from "./Fundraisers.vue?vue&type=script&lang=js&"
import style0 from "./Fundraisers.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Fundraisers.vue?vue&type=style&index=1&id=4d826d23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d826d23",
  null
  
)

component.options.__file = "Fundraisers.vue"
export default component.exports